function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraRefresh = function SvgCameraRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12 8.819v14.457c0 .887.742 1.607 1.659 1.607h23.223c.916 0 1.659-.72 1.659-1.607V8.82c0-.887-.743-1.606-1.66-1.606H27.31L23.992 4h-7.204L13.47 7.213H8.78c-.917 0-1.66.719-1.66 1.606zm4.976-4.82 2.346-2.27a3.373 3.373 0 0 1 2.346-.942h7.204c.88 0 1.724.339 2.346.941L28.684 4h3.318c2.748 0 4.976 2.157 4.976 4.819v14.457c0 2.662-2.228 4.82-4.976 4.82H8.779c-2.749 0-4.977-2.158-4.977-4.82V8.82c0-2.662 2.228-4.82 4.977-4.82zM9.11 16.852l4.977-4.82 4.976 4.82H15.7c.682 1.856 2.512 3.186 4.663 3.186a5.023 5.023 0 0 0 3.215-1.148l2.282 2.334a8.39 8.39 0 0 1-5.497 2.026c-3.997 0-7.331-2.747-8.1-6.398zm22.892-3.213-4.977 4.82-4.976-4.82h3.042c-.674-1.87-2.511-3.213-4.673-3.213a5.014 5.014 0 0 0-3.086 1.046c-.044.034-2.072-2.509-2.072-2.509a8.4 8.4 0 0 1 5.158-1.75c4.007 0 7.348 2.762 8.105 6.426z",
    style: {
      strokeWidth: 1.95884
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif"
    },
    x: 6.982,
    y: 39.014
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.982,
    y: 39.014,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "FLIP")));
};
export default SvgCameraRefresh;